/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPortfoliosQueries } from '../../models/get-portfolios-queries';
import { GetPortfoliosQueriesResult } from '../../models/get-portfolios-queries-result';

export interface ApiPortfolioGetPortfoliosPost$Plain$Params {
      body?: GetPortfoliosQueries
}

export function apiPortfolioGetPortfoliosPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPortfolioGetPortfoliosPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPortfoliosQueriesResult>> {
  const rb = new RequestBuilder(rootUrl, apiPortfolioGetPortfoliosPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPortfoliosQueriesResult>;
    })
  );
}

apiPortfolioGetPortfoliosPost$Plain.PATH = '/api/Portfolio/GetPortfolios';
